import api from './axios';

const municipalitiesService = {
  getAll: () => api.get('/municipalities'),
  findNearest: ({ lat, lon }) =>
    api.get('/municipalities/nearest', { params: { lat, lon } }),
};

export default municipalitiesService;
